function calculatePower() {
  const typeMoteur = document.getElementById('type_moteur').value;
  const cylindree = parseFloat(document.getElementById('cylindree').value);

  if (!typeMoteur || isNaN(cylindree) || cylindree <= 0) {
    document.getElementById('errorMessage').style.display = 'block';
    return;
  }

  document.getElementById('errorMessage').style.display = 'none';

  let puissanceAdministrative = 0;

  // Calcul selon le type de moteur
  if (typeMoteur === 'essence_diesel_2t') {
    puissanceAdministrative = cylindree * 5.727;
  } else if (typeMoteur === 'diesel_4t') {
    puissanceAdministrative = cylindree * 4.009;
  } else if (typeMoteur === 'electrique') {
    puissanceAdministrative = cylindree / 5.14895;
  }

  // Arrondir à l'unité inférieure
  puissanceAdministrative = Math.floor(puissanceAdministrative);

  // Affichage du résultat
  const resultDiv = document.getElementById('result');
  resultDiv.style.display = 'block';
  resultDiv.innerHTML = `La puissance administrative du moteur est de <strong>${puissanceAdministrative} CV</strong>.`;
}
